export function navigateTo(pathname: string) {
  if (typeof window === 'undefined') return;
  window.history.pushState({}, '', pathname);
  window.dispatchEvent(new PopStateEvent('popstate'));
}
